// Multi-language translations for Vape Yard
// Supports: French (fr - default), Haitian Creole (ht), English (en), Spanish (es)

import { createContext, useContext, useState, useEffect } from "react";
import { setDomLanguage } from "./domTranslator";

const TRANSLATIONS = {
  fr: {
    suspended_title: "VOTRE COMPTE EST SUSPENDU",
    suspended_hint: "Régularisez votre cycle pour redevenir actif.",
    resolve_sales: "Régulariser les ventes",
    resolve_payment: "Régulariser le paiement",
    // Welcome / landing
    welcome_to: "Bienvenue sur",
    select_zone: "Sélectionnez votre zone",
    online: "en ligne",
    platform_tagline:
      "Plateforme de gestion de stock premium. Suivez vos ventes, gérez vos stockers et développez votre réseau à travers le monde.",
    ceo: "CEO",
    manager: "Manager",
    network: "Network",
    inv: "INV",
    language: "Langue",
    // Manager / general
    welcome_manager: "Bienvenue Manager",
    my_stock: "Mon Stock",
    sub_stockers: "Sub-Stockers",
    country_overview: "Aperçu National",
    rapports: "Rapports",
    alerts: "Alertes",
    hookah: "Hookah",
    monthly_bonus: "Bonus Manager",
    sold: "Vendus",
    remaining: "Restant",
    revenue: "Revenus",
    bonus: "Bonus",
    record_sale: "Enregistrer Vente",
    add_sub_stocker: "Ajouter Sub-Stocker",
    sub_stocker_name: "Nom du sub-stocker",
    quantity: "Quantité",
    price: "Prix",
    convert_to_nm: "Convertir en Network Marketer",
    convert_to_stocker: "Convertir en Stocker",
    live_tracking: "Suivi en Direct",
    confirm: "Confirmer",
    cancel: "Annuler",
    save: "Enregistrer",
    logout: "Sortir",
    // Stocker dashboard - stats
    cycle_bonus: "Bonus Cycle",
    vapes_sold: "Vapes Vendus",
    commission: "Commission",
    commission_earned: "Commission Gagnée",
    stock: "Stock",
    remaining_pct_suffix: "restant",
    days: "jours",
    monthly_performance: "Performance Mensuelle",
    vapes_sold_lower: "vapes vendus",
    // Menu tabs
    tab_dashboard: "Tableau de bord",
    tab_sales: "Ventes",
    tab_bonus: "Bonus",
    tab_gifts: "Cadeaux",
    tab_profile: "Profil",
    // Credit Score card
    performance_credit_title: "Performance Mensuelle & Score Crédit",
    credit_score: "Score Crédit",
    why_this_score: "Pourquoi ce score",
    no_penalty_msg: "Aucune pénalité — continuez comme ça !",
    late_incident_label: "Retard",
    late_penalty_detail: "-10 points par retard",
    consecutive_late_label: "Retard prolongé",
    consecutive_late_detail: "-1 point par jour au-delà de 3 jours",
    low_month_label: "Mois faible <50%",
    low_month_detail: "-10 points par mois faible",
    risk_critical: "🚨 RISQUE DE PERDRE LE CONTRAT",
    risk_warning: "⚠️ COMPTE À RISQUE",
    risk_moderate: "🟡 Besoin de Support",
    risk_good: "✅ Compte Solide",
    contract_risk_msg: "🚫 3+ retards — Bannissement automatique recommandé !",
    risk_account_msg: "⚠️ 3+ mois faibles — Compte en alerte",
    late_days_msg_prefix: "⏱️ -1 point par jour après 3 jours de retard",
    weekly_feb: "Faible",
    weekly_bon: "Bon",
    weekly_tres_bon: "Très Bon",
    weekly_ekselan: "Excellent",
    // Gifts
    gift_unlocked: "Cadeau Débloqué !",
    gift_vip: "Cadeau VIP !",
    gift_claim_100: "100 vapes vendus - Réclamez votre cadeau !",
    gift_claim_150: "150 vapes vendus - Cadeau Spécial !",
    gift_ceo_choice: "Le CEO va choisir votre cadeau. Vous serez notifié !",
    total_sales_gift: "vapes vendus au total !",
    // Welcome modal
    welcome_dashboard: "Bienvenue sur ton Dashboard",
    // Profile
    informations: "Informations",
    statistics: "Statistiques",
    pays: "Pays",
    member_since: "Membre depuis",
    end_period: "Fin de période",
    days_remaining: "Jours restants",
    bonus_total: "Bonus Total",
    total_revenue: "Revenus",
    privacy_policy: "Politique de Confidentialité",
    // Alerts
    control_today: "Contrôle aujourd'hui !",
    // Withdraw + renew + total sales
    withdraw_money: "Retirer l'Argent",
    your_gains: "Vos gains",
    vapes_sold_current_cycle: "Vapes vendus (cycle actuel)",
    sales_revenue: "Revenus Ventes",
    bonus_per_vape_label: "Bonus",
    commission_calc: "Commission",
    total_amount: "Montant Total",
    renew_stock: "Renouveler Stock",
    request_pending: "Demande en cours",
    eligible: "Éligible",
    not_eligible_min: "vendu - Non éligible (min 50%)",
    request_renewal: "Demander Renouvellement",
    total_sales_since_start: "Total Ventes (depuis le début)",
    total_vapes_sold: "Vapes vendus au total",
    this_month_sales: "Ce mois",
    sales_word: "ventes",
    per_vape: "par vape",
    my_personal_stock: "Mon Stock Personnel",
    had_available: "Total Reçu",
    sold_short: "Vendus",
    remaining_short: "Restant",
    control_date_short: "Date de contrôle",
    prev_cycle_pending_title: "Cycle précédent non fermé",
    prev_cycle_pending_desc: "En attente du CEO pour valider le contrôle",
    prev_cycle_had: "Reçu",
    prev_cycle_sold: "Vendus",
    prev_cycle_remaining: "Restant",
    support_center: "Support",
    // Common labels
    login: "Connexion",
    next: "Suivant",
    back: "Retour",
    enter: "Entrer",
    // === Network Marketer dashboard ===
    nm_welcome_bureau: "Bienvenue à votre bureau",
    nm_title: "Network Marketer",
    nm_commission: "Commission",
    nm_ceo_message: "Message du CEO",
    nm_stock_personal: "Stock Personnel",
    my_stockers: "Mes Stockers",
    my_sales: "Mes Ventes",
    total_gains: "Gains Total",
    performance: "Performance",
    personal_sales: "Ventes personnelles",
    substocker_sales: "Ventes sub-stockers",
    personal_revenue: "Revenus personnels",
    commission_15_label: "Commission (15%)",
    substocker_bonus: "Bonus sub-stockers",
    bonus_per_vape_2: "Bonus par vape",
    percent_sold_progress: "Stock vendu",
    // Stock tab
    register_sale: "Enregistrer une Vente",
    vape_model: "Modèle de Vape",
    quantity_sold: "Quantité Vendue",
    price_per_unit: "Prix par unité",
    revenue_label: "Revenu",
    save_sale_btn: "Enregistrer la Vente",
    sales_history: "Historique des Ventes",
    earnings_summary: "Résumé Gains",
    // Renew
    renew_stock_2: "Renouveler Stock",
    request_renewal_btn: "Demander Renouvellement",
    not_eligible: "Non Éligible",
    sales_below_50: "Ventes inférieures à 50%. Contactez votre Manager.",
    return_btn: "Retour",
    request_accepted: "Demande Acceptée!",
    ceo_will_add_stock: "Le CEO va ajouter votre stock bientôt.",
    // Stockers tab
    add_stocker_st: "Ajouter Stocker",
    new_stocker: "Nouveau Stocker",
    stocker_name_label: "Nom du stocker",
    stock_batch_label: "Nom du Lot (Stock Batch)",
    stock_batch_placeholder: "Ex: Stock A, Stock B...",
    models_uppercase: "MODÈLES DE VAPE",
    add_model_btn: "+ Modèle",
    payment_info_optional: "Info paiement (optionnel)",
    add_btn: "Ajouter",
    no_first_stocker: "Ajoutez votre premier stocker",
    stock_short: "Stock",
    sold_col: "Vendus",
    remaining_col: "Restant",
    price_col: "Prix",
    edit_stock: "Modifier Stock",
    quantity_max_10: "Quantité (max 10)",
    price_dollars: "Prix ($)",
    save_btn: "Sauvegarder",
    model_placeholder: "Modèle",
    qty_placeholder: "Qté",
    price_placeholder: "Prix $",
    pay_stocker: "Payer",
    paid_label: "Payé",
    start_col: "Début",
    control_col: "Contrôle",
    // Bonus tab
    bonus_card_recharge: "Bonus Carte Recharge",
    bonus_card_daily: "$0.43/jour jusqu'à $10",
    withdraw_short: "Retirer",
    not_available: "Non disponible",
    bonus_per_sold: "Bonus par Vape Vendue",
    bonus_per_vape_stat: "Bonus / Vape",
    total_bonus_stat: "Total Bonus",
    // Retrait tab
    contact_ceo_gains: "Contactez le CEO pour recevoir vos gains",
    total_earnings_label: "Total Earnings",
    commission_break_label: "Commission",
    bonus_card_label: "Bonus Carte",
    total_amount_label: "Montant Total",
    please_wait: "Veuillez patienter...",
    processing_short: "Traitement en cours",
    request_approved: "Demande Approuvée!",
    contact_ceo_wa: "Contactez votre CEO pour recevoir vos gains",
    contact_ceo_whatsapp_btn: "Contacter CEO via WhatsApp",
    close_btn: "Fermer",
    // Notif tab
    notifications_label: "Notifications",
    no_notifications: "Aucune notification",
    mark_read: "Lu",
    // Withdraw bonus modal
    withdraw_bonus_card: "Retirer Bonus Carte",
    number_receive_card: "Numéro pour recevoir la carte",
    access_sent: "Accès Envoyé!",
    receive_card_delay: "Vous recevrez la carte dans 24-48hrs",
    // Profile (shared)
    change_photo: "Changer photo",
    upload_photo: "Ajouter photo",
    // Dates section
    date_start: "Date Début",
    date_control: "Date Contrôle",
    days_left: "Jours Restants",
    delete_confirm_stocker: "Êtes-vous sûr de vouloir supprimer ce stocker?",
    // Errors
    enter_valid_number: "Entrez un numéro valide",
    fill_name_model: "Remplissez le nom et au moins un modèle",
    enter_valid_quantity: "Entrez une quantité valide",
    enter_valid_price: "Entrez un prix valide",
    enter_model_name: "Entrez le nom du modèle",
    error_generic: "Erreur",
    sale_recorded: "Vente enregistrée!",
    stocker_added: "Stocker ajouté!",
    stocker_deleted: "Stocker supprimé!",
    stock_modified: "Stock modifié!",
    payment_confirmed: "Paiement confirmé! Le CEO sera notifié.",
    // Payment Profile Card
    pp_active_method: "Ma Méthode de Paiement Active",
    pp_whatsapp_hint: "Ces infos apparaîtront sur WhatsApp CEO chaque fois que vous cliquez « Retirer l'Argent ».",
    pp_cash_label: "Cash",
    pp_zelle_id_label: "Numéro Zelle (téléphone/email)",
    pp_cashapp_tag_label: "Tag Cash App",
    pp_account_holder: "Nom sur le compte",
    pp_full_name: "Nom complet",
    pp_phone_hint: "Téléphone (visible par le CEO WhatsApp)",
    pp_save_btn: "Enregistrer Méthode de Paiement",
    pp_saving: "Enregistrement...",
    pp_choose_method: "Choisissez une méthode de paiement",
    pp_fill_account: "Remplissez ID compte et nom",
    pp_saved: "Méthode de paiement enregistrée",
    pp_save_error: "Erreur d'enregistrement",
    cycle_recovery_label: "Récupération du cycle",
    cycle_recovery_detail: "+10 pour ≥50% • +20 pour 100%",
    manual_adjust_label: "Ajustement manuel (CEO)",
    manual_adjust_detail: "points manuels",
    notifications_title: "Notifications",
    notif_all_read: "Tout lire",
    notif_none: "Aucune notification",
    notif_click_hint: "Cliquez pour voir",
    select_payment_method: "Sélectionnez votre méthode de paiement",
    payment_method_required: "Choisissez d'abord une méthode",
    // Sales page (stocker/manager)
    record_sales_header: "Enregistrer Ventes",
    record_sales_btn: "Enregistrer Ventes",
    vape_description: "Description du vape",
    vape_description_num: "Vape Description",
    price_sold: "Prix Vendu ($)",
    subtotal: "Sous-total",
    total_sales_label: "Total Ventes",
    bonus_to_receive: "Bonus à recevoir",
    // Carryover
    carryover_cleared: "✅ Carryover sik pase a fin vann",
    carryover_cleared_hint: "Bon travay — pi gwo priyorite an premye",
    carryover_pending_title: "⚠️ Vape rete de sik ki te pase a",
    carryover_pending_hint: "Dwe vann nan sik aktyèl la",
  },
  ht: {
    suspended_title: "KONT OU SISPANN",
    suspended_hint: "Rezoud sik ou pou tounen aktif.",
    resolve_sales: "Rezoud Vant",
    resolve_payment: "Rezoud Peman",
    welcome_to: "Byenveni sou",
    select_zone: "Chwazi zòn ou",
    online: "an liy",
    platform_tagline:
      "Platfòm jesyon stock premium. Swiv vant ou yo, jere stockers ou yo epi devlope rezo ou nan mond lan.",
    ceo: "CEO",
    manager: "Manadjè",
    network: "Network",
    inv: "INV",
    language: "Lang",
    welcome_manager: "Byenveni Manadjè",
    my_stock: "Stock Pèsonèl Mwen",
    sub_stockers: "Sub-Stockers Mwen",
    country_overview: "Apèsi Nasyonal",
    rapports: "Rapò",
    alerts: "Alèt",
    hookah: "Hookah",
    monthly_bonus: "Bonus Manadjè",
    sold: "Vann",
    remaining: "Rete",
    revenue: "Revni",
    bonus: "Bonus",
    record_sale: "Anrejistre Vant",
    add_sub_stocker: "Ajoute Sub-Stocker",
    sub_stocker_name: "Non sub-stocker la",
    quantity: "Kantite",
    price: "Pri",
    convert_to_nm: "Konvèti an Network Marketer",
    convert_to_stocker: "Konvèti an Stocker",
    live_tracking: "Swiv an Dirèk",
    confirm: "Konfime",
    cancel: "Anile",
    save: "Anrejistre",
    logout: "Soti",
    cycle_bonus: "Bonus Sik la",
    vapes_sold: "Vape Vann",
    commission: "Komisyon",
    commission_earned: "Komisyon Genyen",
    stock: "Stock",
    remaining_pct_suffix: "rete",
    days: "jou",
    monthly_performance: "Pèfòmans Mansyèl",
    vapes_sold_lower: "vape vann",
    tab_dashboard: "Tablo bò",
    tab_sales: "Vant",
    tab_bonus: "Bonus",
    tab_gifts: "Kado",
    tab_profile: "Pwofil",
    performance_credit_title: "Pèfòmans Mansyèl & Credit Score",
    credit_score: "Credit Score",
    why_this_score: "Poukisa Score Sa a",
    no_penalty_msg: "Pa gen okenn penalizasyon — kenbe ap fè byen!",
    late_incident_label: "Reta",
    late_penalty_detail: "-10 pwen chak reta",
    consecutive_late_label: "Retard konsekan",
    consecutive_late_detail: "-1 pwen chak jou apre 3 jou reta",
    low_month_label: "Mwa < 50%",
    low_month_detail: "-10 pwen chak mwa fèb",
    risk_critical: "🚨 RISK PÈDI KONTRÈ",
    risk_warning: "⚠️ RISK ACCOUNT",
    risk_moderate: "🟡 Bezwen Sipò",
    risk_good: "✅ Kont Solid",
    contract_risk_msg: "🚫 3+ reta — Otomatik-BANI ka rekòmande!",
    risk_account_msg: "⚠️ 3+ mwa ba — Kont sou alèt",
    late_days_msg_prefix: "⏱️ -1 pwen chak jou apre 3 jou reta",
    weekly_feb: "Feb",
    weekly_bon: "Bon",
    weekly_tres_bon: "Trè Bon",
    weekly_ekselan: "Ekselan",
    gift_unlocked: "Kado Debloke!",
    gift_vip: "Kado VIP!",
    gift_claim_100: "100 vape vann - Reklame kado ou!",
    gift_claim_150: "150 vape vann - Kado Espesyal!",
    gift_ceo_choice: "CEO a ap chwazi kado ou. W ap resevwa notifikasyon!",
    total_sales_gift: "vape vann an total!",
    welcome_dashboard: "Byenveni sou Dashboard ou",
    informations: "Enfòmasyon",
    statistics: "Estatistik",
    pays: "Peyi",
    member_since: "Manb depi",
    end_period: "Fen peryòd",
    days_remaining: "Jou ki rete",
    bonus_total: "Bonus Total",
    total_revenue: "Revni",
    privacy_policy: "Politik Konfidansyalite",
    control_today: "Kontwòl jodi a!",
    my_personal_stock: "Stock Pèsonèl Mwen",
    had_available: "Te Gen",
    sold_short: "Vann",
    remaining_short: "Rete",
    control_date_short: "Dat kontwòl",
    prev_cycle_pending_title: "Sik anvan an poko fèmen",
    prev_cycle_pending_desc: "Tann CEO peze Kontwòl Efektye",
    prev_cycle_had: "Te gen",
    prev_cycle_sold: "Vann",
    prev_cycle_remaining: "Rete",
    support_center: "Sipò",
    login: "Konekte",
    next: "Swivan",
    back: "Retounen",
    enter: "Antre",
    // === Network Marketer dashboard ===
    nm_welcome_bureau: "Byenveni nan biwo w",
    nm_title: "Network Marketer",
    nm_commission: "Komisyon",
    nm_ceo_message: "Mesaj CEO a",
    nm_stock_personal: "Stock Pèsonèl",
    my_stockers: "Stockers Mwen",
    my_sales: "Vant Mwen",
    total_gains: "Total Gen",
    performance: "Pèfòmans",
    personal_sales: "Vant pèsonèl",
    substocker_sales: "Vant sub-stockers",
    personal_revenue: "Revni pèsonèl",
    commission_15_label: "Komisyon (15%)",
    substocker_bonus: "Bonus sub-stockers",
    bonus_per_vape_2: "Bonus pa vape",
    percent_sold_progress: "Stock vann",
    register_sale: "Anrejistre yon Vant",
    vape_model: "Modèl Vape",
    quantity_sold: "Kantite Vann",
    price_per_unit: "Pri pa inite",
    revenue_label: "Revni",
    save_sale_btn: "Anrejistre Vant lan",
    sales_history: "Istorik Vant",
    earnings_summary: "Rezime Gen",
    renew_stock_2: "Renouvle Stock",
    request_renewal_btn: "Mande Renouvèlman",
    not_eligible: "Pa Kalifye",
    sales_below_50: "Vant yo poko rive 50%. Kontakte Manadjè w.",
    return_btn: "Retounen",
    request_accepted: "Demand Aksepte!",
    ceo_will_add_stock: "Ekip Vape Yard ap ajoute stock ou byento.",
    stock_in_progress: "Stock ou an ap prepare...",
    add_stocker_st: "Ajoute Stocker",
    new_stocker: "Nouvo Stocker",
    stocker_name_label: "Non stocker la",
    stock_batch_label: "Non Lo a (Stock Batch)",
    stock_batch_placeholder: "Egz: Stock A, Stock B...",
    models_uppercase: "MODÈL VAPE",
    add_model_btn: "+ Modèl",
    payment_info_optional: "Enfo peman (opsyonèl)",
    add_btn: "Ajoute",
    no_first_stocker: "Ajoute premye stocker w",
    stock_short: "Stock",
    sold_col: "Vann",
    remaining_col: "Rete",
    price_col: "Pri",
    edit_stock: "Modifye Stock",
    quantity_max_10: "Kantite (max 10)",
    price_dollars: "Pri ($)",
    save_btn: "Sove",
    model_placeholder: "Modèl",
    qty_placeholder: "Qte",
    price_placeholder: "Pri $",
    pay_stocker: "Peye",
    paid_label: "Peye",
    start_col: "Kòmanse",
    control_col: "Kontwòl",
    bonus_card_recharge: "Bonus Kat Rechaj",
    bonus_card_daily: "$0.43/jou jiska $10",
    withdraw_short: "Retire",
    not_available: "Pa disponib",
    bonus_per_sold: "Bonus pa Vape Vann",
    bonus_per_vape_stat: "Bonus / Vape",
    total_bonus_stat: "Total Bonus",
    contact_ceo_gains: "Kontakte CEO a pou resevwa gen w",
    total_earnings_label: "Total Earnings",
    commission_break_label: "Komisyon",
    bonus_card_label: "Bonus Kat",
    total_amount_label: "Total",
    please_wait: "Tanpri tann...",
    processing_short: "N ap trete",
    request_approved: "Demand Aprouve!",
    contact_ceo_wa: "Kontakte CEO w pou resevwa gen w",
    contact_ceo_whatsapp_btn: "Kontakte CEO via WhatsApp",
    close_btn: "Fèmen",
    notifications_label: "Notifikasyon",
    no_notifications: "Pa gen notifikasyon",
    mark_read: "Li",
    withdraw_bonus_card: "Retire Bonus Kat",
    number_receive_card: "Nimewo pou resevwa kat la",
    access_sent: "Aksè Voye!",
    receive_card_delay: "W ap resevwa kat la nan 24-48h",
    change_photo: "Chanje foto",
    upload_photo: "Ajoute foto",
    date_start: "Dat Kòmansman",
    date_control: "Dat Kontwòl",
    days_left: "Jou Rete",
    delete_confirm_stocker: "Ou sèten ou vle efase stocker sa?",
    enter_valid_number: "Antre yon nimewo valid",
    fill_name_model: "Ranpli non ak omwen yon modèl",
    enter_valid_quantity: "Antre yon kantite valid",
    enter_valid_price: "Antre yon pri valid",
    enter_model_name: "Antre non modèl la",
    error_generic: "Erè",
    sale_recorded: "Vant anrejistre!",
    stocker_added: "Stocker ajoute!",
    stocker_deleted: "Stocker efase!",
    stock_modified: "Stock modifye!",
    payment_confirmed: "Peman konfime! CEO a ap resevwa notifikasyon.",
    pp_active_method: "Metòd Peman Aktif Mwen",
    pp_whatsapp_hint: "Enfòmasyon sa ap sanble sou WhatsApp CEO a chak fwa w peze « Retire Lajan ».",
    pp_cash_label: "Cash",
    pp_zelle_id_label: "Nimewo Zelle (telefòn/imel)",
    pp_cashapp_tag_label: "Cash App Tag",
    pp_account_holder: "Non sou kont lan",
    pp_full_name: "Non konplè",
    pp_phone_hint: "Telefòn (WhatsApp CEO ap wè)",
    pp_save_btn: "Anrejistre Metòd Peman",
    pp_saving: "Anrejistre...",
    pp_choose_method: "Chwazi yon metòd peman",
    pp_fill_account: "Ranpli ID kont ak non",
    pp_saved: "Metòd peman ou anrejistre",
    pp_save_error: "Erè anrejistreman",
    // Sales page
    record_sales_header: "Anrejistre Vant",
    record_sales_btn: "Anrejistre Vant",
    vape_description: "Deskripsyon vape la",
    vape_description_num: "Deskripsyon Vape",
    price_sold: "Pri Vann ($)",
    subtotal: "Soutotal",
    total_sales_label: "Total Vant",
    bonus_to_receive: "Bonus w ap resevwa",
    // Carryover
    carryover_cleared: "✅ Carryover sik pase a fin vann",
    carryover_cleared_hint: "Bon travay — pi gwo priyorite an premye",
    carryover_pending_title: "⚠️ Vape rete de sik ki te pase a",
    carryover_pending_hint: "Dwe vann nan sik aktyèl la",
  },
  en: {
    suspended_title: "YOUR ACCOUNT IS SUSPENDED",
    suspended_hint: "Settle your cycle to become active again.",
    resolve_sales: "Settle sales",
    resolve_payment: "Settle payment",
    welcome_to: "Welcome to",
    select_zone: "Select your zone",
    online: "online",
    platform_tagline:
      "Premium stock management platform. Track your sales, manage your stockers and grow your network worldwide.",
    ceo: "CEO",
    manager: "Manager",
    network: "Network",
    inv: "INV",
    language: "Language",
    welcome_manager: "Welcome Manager",
    my_stock: "My Stock",
    sub_stockers: "Sub-Stockers",
    country_overview: "Country Overview",
    rapports: "Reports",
    alerts: "Alerts",
    hookah: "Hookah",
    monthly_bonus: "Manager Bonus",
    sold: "Sold",
    remaining: "Remaining",
    revenue: "Revenue",
    bonus: "Bonus",
    record_sale: "Record Sale",
    add_sub_stocker: "Add Sub-Stocker",
    sub_stocker_name: "Sub-stocker name",
    quantity: "Quantity",
    price: "Price",
    convert_to_nm: "Convert to Network Marketer",
    convert_to_stocker: "Convert to Stocker",
    live_tracking: "Live Tracking",
    confirm: "Confirm",
    cancel: "Cancel",
    save: "Save",
    logout: "Logout",
    cycle_bonus: "Cycle Bonus",
    vapes_sold: "Vapes Sold",
    commission: "Commission",
    commission_earned: "Commission Earned",
    stock: "Stock",
    remaining_pct_suffix: "remaining",
    days: "days",
    monthly_performance: "Monthly Performance",
    vapes_sold_lower: "vapes sold",
    tab_dashboard: "Dashboard",
    tab_sales: "Sales",
    tab_bonus: "Bonus",
    tab_gifts: "Gifts",
    tab_profile: "Profile",
    performance_credit_title: "Monthly Performance & Credit Score",
    credit_score: "Credit Score",
    why_this_score: "Why This Score",
    no_penalty_msg: "No penalty — keep it up!",
    late_incident_label: "Late",
    late_penalty_detail: "-10 points per late incident",
    consecutive_late_label: "Extended Late",
    consecutive_late_detail: "-1 point per day beyond 3 days",
    low_month_label: "Low Month <50%",
    low_month_detail: "-10 points per low month",
    risk_critical: "🚨 CONTRACT LOSS RISK",
    risk_warning: "⚠️ ACCOUNT AT RISK",
    risk_moderate: "🟡 Needs Support",
    risk_good: "✅ Solid Account",
    contract_risk_msg: "🚫 3+ lates — Auto-BAN recommended!",
    risk_account_msg: "⚠️ 3+ low months — Account flagged",
    late_days_msg_prefix: "⏱️ -1 point per day after 3 days late",
    weekly_feb: "Weak",
    weekly_bon: "Good",
    weekly_tres_bon: "Very Good",
    weekly_ekselan: "Excellent",
    gift_unlocked: "Gift Unlocked!",
    gift_vip: "VIP Gift!",
    gift_claim_100: "100 vapes sold - Claim your gift!",
    gift_claim_150: "150 vapes sold - Special Gift!",
    gift_ceo_choice: "The CEO will pick your gift. You will be notified!",
    total_sales_gift: "vapes sold in total!",
    welcome_dashboard: "Welcome to your Dashboard",
    informations: "Information",
    statistics: "Statistics",
    pays: "Country",
    member_since: "Member since",
    end_period: "End of period",
    days_remaining: "Days remaining",
    bonus_total: "Total Bonus",
    total_revenue: "Revenue",
    privacy_policy: "Privacy Policy",
    control_today: "Control today!",
    withdraw_money: "Withdraw Money",
    your_gains: "Your gains",
    vapes_sold_current_cycle: "Vapes sold (current cycle)",
    sales_revenue: "Sales Revenue",
    bonus_per_vape_label: "Bonus",
    commission_calc: "Commission",
    total_amount: "Total Amount",
    renew_stock: "Renew Stock",
    request_pending: "Request pending",
    eligible: "Eligible",
    not_eligible_min: "sold - Not eligible (min 50%)",
    request_renewal: "Request Renewal",
    total_sales_since_start: "Total Sales (since start)",
    total_vapes_sold: "Total vapes sold",
    this_month_sales: "This month",
    sales_word: "sales",
    per_vape: "per vape",
    my_personal_stock: "My Personal Stock",
    had_available: "Received",
    sold_short: "Sold",
    remaining_short: "Remaining",
    control_date_short: "Control Date",
    prev_cycle_pending_title: "Previous cycle not closed",
    prev_cycle_pending_desc: "Waiting for CEO to validate control",
    prev_cycle_had: "Received",
    prev_cycle_sold: "Sold",
    prev_cycle_remaining: "Remaining",
    support_center: "Support",
    login: "Login",
    next: "Next",
    back: "Back",
    enter: "Enter",
    nm_welcome_bureau: "Welcome to your office",
    nm_title: "Network Marketer",
    nm_commission: "Commission",
    nm_ceo_message: "CEO message",
    nm_stock_personal: "Personal Stock",
    my_stockers: "My Stockers",
    my_sales: "My Sales",
    total_gains: "Total Earnings",
    performance: "Performance",
    personal_sales: "Personal sales",
    substocker_sales: "Sub-stocker sales",
    personal_revenue: "Personal revenue",
    commission_15_label: "Commission (15%)",
    substocker_bonus: "Sub-stocker bonus",
    bonus_per_vape_2: "Bonus per vape",
    percent_sold_progress: "Stock sold",
    register_sale: "Record a Sale",
    vape_model: "Vape Model",
    quantity_sold: "Quantity Sold",
    price_per_unit: "Price per unit",
    revenue_label: "Revenue",
    save_sale_btn: "Save Sale",
    sales_history: "Sales History",
    earnings_summary: "Earnings Summary",
    renew_stock_2: "Renew Stock",
    request_renewal_btn: "Request Renewal",
    not_eligible: "Not Eligible",
    sales_below_50: "Sales below 50%. Contact your Manager.",
    return_btn: "Back",
    request_accepted: "Request Accepted!",
    ceo_will_add_stock: "The Vape Yard team will add your stock soon.",
    stock_in_progress: "Your stock is being prepared...",
    add_stocker_st: "Add Stocker",
    new_stocker: "New Stocker",
    stocker_name_label: "Stocker name",
    stock_batch_label: "Batch Name (Stock Batch)",
    stock_batch_placeholder: "Ex: Stock A, Stock B...",
    models_uppercase: "VAPE MODELS",
    add_model_btn: "+ Model",
    payment_info_optional: "Payment info (optional)",
    add_btn: "Add",
    no_first_stocker: "Add your first stocker",
    stock_short: "Stock",
    sold_col: "Sold",
    remaining_col: "Remaining",
    price_col: "Price",
    edit_stock: "Edit Stock",
    quantity_max_10: "Quantity (max 10)",
    price_dollars: "Price ($)",
    save_btn: "Save",
    model_placeholder: "Model",
    qty_placeholder: "Qty",
    price_placeholder: "Price $",
    pay_stocker: "Pay",
    paid_label: "Paid",
    start_col: "Start",
    control_col: "Control",
    bonus_card_recharge: "Recharge Bonus Card",
    bonus_card_daily: "$0.43/day up to $10",
    withdraw_short: "Withdraw",
    not_available: "Not available",
    bonus_per_sold: "Bonus per Vape Sold",
    bonus_per_vape_stat: "Bonus / Vape",
    total_bonus_stat: "Total Bonus",
    contact_ceo_gains: "Contact the CEO to receive your earnings",
    total_earnings_label: "Total Earnings",
    commission_break_label: "Commission",
    bonus_card_label: "Bonus Card",
    total_amount_label: "Total Amount",
    please_wait: "Please wait...",
    processing_short: "Processing",
    request_approved: "Request Approved!",
    contact_ceo_wa: "Contact your CEO to receive your earnings",
    contact_ceo_whatsapp_btn: "Contact CEO via WhatsApp",
    close_btn: "Close",
    notifications_label: "Notifications",
    no_notifications: "No notifications",
    mark_read: "Read",
    withdraw_bonus_card: "Withdraw Bonus Card",
    number_receive_card: "Phone number to receive card",
    access_sent: "Access Sent!",
    receive_card_delay: "You'll receive the card in 24-48hrs",
    change_photo: "Change photo",
    upload_photo: "Upload photo",
    date_start: "Start Date",
    date_control: "Control Date",
    days_left: "Days Left",
    delete_confirm_stocker: "Are you sure you want to delete this stocker?",
    enter_valid_number: "Enter a valid number",
    fill_name_model: "Fill in name and at least one model",
    enter_valid_quantity: "Enter a valid quantity",
    enter_valid_price: "Enter a valid price",
    enter_model_name: "Enter model name",
    error_generic: "Error",
    sale_recorded: "Sale recorded!",
    stocker_added: "Stocker added!",
    stocker_deleted: "Stocker deleted!",
    stock_modified: "Stock updated!",
    payment_confirmed: "Payment confirmed! CEO will be notified.",
    pp_active_method: "My Active Payment Method",
    pp_whatsapp_hint: "This info will appear on the CEO's WhatsApp every time you press \"Withdraw Money\".",
    pp_cash_label: "Cash",
    pp_zelle_id_label: "Zelle number (phone/email)",
    pp_cashapp_tag_label: "Cash App Tag",
    pp_account_holder: "Name on account",
    pp_full_name: "Full name",
    pp_phone_hint: "Phone (visible on CEO WhatsApp)",
    pp_save_btn: "Save Payment Method",
    pp_saving: "Saving...",
    pp_choose_method: "Choose a payment method",
    pp_fill_account: "Fill account ID and name",
    pp_saved: "Payment method saved",
    pp_save_error: "Save error",
    cycle_recovery_label: "Cycle recovery",
    cycle_recovery_detail: "+10 for ≥50% • +20 for 100%",
    manual_adjust_label: "Manual adjust (CEO)",
    manual_adjust_detail: "manual points",
    notifications_title: "Notifications",
    notif_all_read: "Mark all read",
    notif_none: "No notifications",
    notif_click_hint: "Click to view",
    select_payment_method: "Select your payment method",
    payment_method_required: "Choose a payment method first",
    // Sales page
    record_sales_header: "Record Sales",
    record_sales_btn: "Record Sales",
    vape_description: "Vape description",
    vape_description_num: "Vape Description",
    price_sold: "Sold Price ($)",
    subtotal: "Subtotal",
    total_sales_label: "Total Sales",
    bonus_to_receive: "Bonus to receive",
    // Carryover
    carryover_cleared: "✅ Previous-cycle carryover fully sold",
    carryover_cleared_hint: "Great — top priority cleared",
    carryover_pending_title: "⚠️ Vapes left from the previous cycle",
    carryover_pending_hint: "Must be sold in the current cycle",
  },
  es: {
    suspended_title: "TU CUENTA ESTÁ SUSPENDIDA",
    suspended_hint: "Regulariza tu ciclo para volver a estar activo.",
    resolve_sales: "Regularizar ventas",
    resolve_payment: "Regularizar pago",
    welcome_to: "Bienvenido a",
    select_zone: "Selecciona tu zona",
    online: "en línea",
    platform_tagline:
      "Plataforma premium de gestión de inventario. Sigue tus ventas, gestiona tus stockers y haz crecer tu red en todo el mundo.",
    ceo: "CEO",
    manager: "Manager",
    network: "Network",
    inv: "INV",
    language: "Idioma",
    welcome_manager: "Bienvenido Manager",
    my_stock: "Mi Stock",
    sub_stockers: "Sub-Stockers",
    country_overview: "Resumen del País",
    rapports: "Informes",
    alerts: "Alertas",
    hookah: "Hookah",
    monthly_bonus: "Bono Manager",
    sold: "Vendidos",
    remaining: "Restantes",
    revenue: "Ingresos",
    bonus: "Bono",
    record_sale: "Registrar Venta",
    add_sub_stocker: "Añadir Sub-Stocker",
    sub_stocker_name: "Nombre del sub-stocker",
    quantity: "Cantidad",
    price: "Precio",
    convert_to_nm: "Convertir a Network Marketer",
    convert_to_stocker: "Convertir a Stocker",
    live_tracking: "Seguimiento en Vivo",
    confirm: "Confirmar",
    cancel: "Cancelar",
    save: "Guardar",
    logout: "Salir",
    cycle_bonus: "Bono del Ciclo",
    vapes_sold: "Vapes Vendidos",
    commission: "Comisión",
    commission_earned: "Comisión Ganada",
    stock: "Stock",
    remaining_pct_suffix: "restante",
    days: "días",
    monthly_performance: "Rendimiento Mensual",
    vapes_sold_lower: "vapes vendidos",
    tab_dashboard: "Panel",
    tab_sales: "Ventas",
    tab_bonus: "Bono",
    tab_gifts: "Regalos",
    tab_profile: "Perfil",
    performance_credit_title: "Rendimiento Mensual & Puntaje de Crédito",
    credit_score: "Puntaje de Crédito",
    why_this_score: "Por qué este puntaje",
    no_penalty_msg: "¡Sin penalizaciones — sigue así!",
    late_incident_label: "Retraso",
    late_penalty_detail: "-10 puntos por retraso",
    consecutive_late_label: "Retraso prolongado",
    consecutive_late_detail: "-1 punto por día después de 3 días",
    low_month_label: "Mes bajo <50%",
    low_month_detail: "-10 puntos por mes bajo",
    risk_critical: "🚨 RIESGO DE PERDER CONTRATO",
    risk_warning: "⚠️ CUENTA EN RIESGO",
    risk_moderate: "🟡 Necesita Apoyo",
    risk_good: "✅ Cuenta Sólida",
    contract_risk_msg: "🚫 3+ retrasos — ¡Bloqueo automático recomendado!",
    risk_account_msg: "⚠️ 3+ meses bajos — Cuenta en alerta",
    late_days_msg_prefix: "⏱️ -1 punto por día después de 3 días de retraso",
    weekly_feb: "Débil",
    weekly_bon: "Bueno",
    weekly_tres_bon: "Muy Bueno",
    weekly_ekselan: "Excelente",
    gift_unlocked: "¡Regalo Desbloqueado!",
    gift_vip: "¡Regalo VIP!",
    gift_claim_100: "100 vapes vendidos - ¡Reclama tu regalo!",
    gift_claim_150: "150 vapes vendidos - ¡Regalo Especial!",
    gift_ceo_choice: "El CEO elegirá tu regalo. ¡Serás notificado!",
    total_sales_gift: "vapes vendidos en total!",
    welcome_dashboard: "Bienvenido a tu Panel",
    informations: "Información",
    statistics: "Estadísticas",
    pays: "País",
    member_since: "Miembro desde",
    end_period: "Fin del período",
    days_remaining: "Días restantes",
    bonus_total: "Bono Total",
    total_revenue: "Ingresos",
    privacy_policy: "Política de Privacidad",
    control_today: "¡Control hoy!",
    withdraw_money: "Retirar Dinero",
    your_gains: "Tus ganancias",
    vapes_sold_current_cycle: "Vapes vendidos (ciclo actual)",
    sales_revenue: "Ingresos de Ventas",
    bonus_per_vape_label: "Bono",
    commission_calc: "Comisión",
    total_amount: "Monto Total",
    renew_stock: "Renovar Stock",
    request_pending: "Solicitud pendiente",
    eligible: "Elegible",
    not_eligible_min: "vendido - No elegible (min 50%)",
    request_renewal: "Solicitar Renovación",
    total_sales_since_start: "Ventas Totales (desde el inicio)",
    total_vapes_sold: "Total de vapes vendidos",
    this_month_sales: "Este mes",
    sales_word: "ventas",
    per_vape: "por vape",
    my_personal_stock: "Mi Stock Personal",
    had_available: "Recibido",
    sold_short: "Vendidos",
    remaining_short: "Restante",
    control_date_short: "Fecha de control",
    prev_cycle_pending_title: "Ciclo anterior no cerrado",
    prev_cycle_pending_desc: "Esperando al CEO para validar el control",
    prev_cycle_had: "Recibido",
    prev_cycle_sold: "Vendidos",
    prev_cycle_remaining: "Restante",
    support_center: "Soporte",
    login: "Iniciar sesión",
    next: "Siguiente",
    back: "Atrás",
    enter: "Entrar",
    nm_welcome_bureau: "Bienvenido a tu oficina",
    nm_title: "Network Marketer",
    nm_commission: "Comisión",
    nm_ceo_message: "Mensaje del CEO",
    nm_stock_personal: "Stock Personal",
    my_stockers: "Mis Stockers",
    my_sales: "Mis Ventas",
    total_gains: "Ganancias Totales",
    performance: "Rendimiento",
    personal_sales: "Ventas personales",
    substocker_sales: "Ventas sub-stockers",
    personal_revenue: "Ingresos personales",
    commission_15_label: "Comisión (15%)",
    substocker_bonus: "Bono sub-stockers",
    bonus_per_vape_2: "Bono por vape",
    percent_sold_progress: "Stock vendido",
    register_sale: "Registrar una Venta",
    vape_model: "Modelo de Vape",
    quantity_sold: "Cantidad Vendida",
    price_per_unit: "Precio por unidad",
    revenue_label: "Ingresos",
    save_sale_btn: "Registrar Venta",
    sales_history: "Historial de Ventas",
    earnings_summary: "Resumen Ganancias",
    renew_stock_2: "Renovar Stock",
    request_renewal_btn: "Solicitar Renovación",
    not_eligible: "No Elegible",
    sales_below_50: "Ventas por debajo del 50%. Contacta a tu Manager.",
    return_btn: "Atrás",
    request_accepted: "¡Solicitud Aceptada!",
    ceo_will_add_stock: "El equipo Vape Yard agregará tu stock pronto.",
    stock_in_progress: "Tu stock está en preparación...",
    add_stocker_st: "Añadir Stocker",
    new_stocker: "Nuevo Stocker",
    stocker_name_label: "Nombre del stocker",
    stock_batch_label: "Nombre del Lote (Stock Batch)",
    stock_batch_placeholder: "Ej: Stock A, Stock B...",
    models_uppercase: "MODELOS DE VAPE",
    add_model_btn: "+ Modelo",
    payment_info_optional: "Info pago (opcional)",
    add_btn: "Añadir",
    no_first_stocker: "Añade tu primer stocker",
    stock_short: "Stock",
    sold_col: "Vendidos",
    remaining_col: "Restante",
    price_col: "Precio",
    edit_stock: "Editar Stock",
    quantity_max_10: "Cantidad (max 10)",
    price_dollars: "Precio ($)",
    save_btn: "Guardar",
    model_placeholder: "Modelo",
    qty_placeholder: "Cant",
    price_placeholder: "Precio $",
    pay_stocker: "Pagar",
    paid_label: "Pagado",
    start_col: "Inicio",
    control_col: "Control",
    bonus_card_recharge: "Bono Tarjeta Recarga",
    bonus_card_daily: "$0.43/día hasta $10",
    withdraw_short: "Retirar",
    not_available: "No disponible",
    bonus_per_sold: "Bono por Vape Vendido",
    bonus_per_vape_stat: "Bono / Vape",
    total_bonus_stat: "Bono Total",
    contact_ceo_gains: "Contacta al CEO para recibir tus ganancias",
    total_earnings_label: "Ganancias Totales",
    commission_break_label: "Comisión",
    bonus_card_label: "Bono Tarjeta",
    total_amount_label: "Monto Total",
    please_wait: "Espera por favor...",
    processing_short: "Procesando",
    request_approved: "¡Solicitud Aprobada!",
    contact_ceo_wa: "Contacta a tu CEO para recibir tus ganancias",
    contact_ceo_whatsapp_btn: "Contactar CEO via WhatsApp",
    close_btn: "Cerrar",
    notifications_label: "Notificaciones",
    no_notifications: "Sin notificaciones",
    mark_read: "Leído",
    withdraw_bonus_card: "Retirar Bono Tarjeta",
    number_receive_card: "Número para recibir la tarjeta",
    access_sent: "¡Acceso Enviado!",
    receive_card_delay: "Recibirás la tarjeta en 24-48hrs",
    change_photo: "Cambiar foto",
    upload_photo: "Subir foto",
    date_start: "Fecha Inicio",
    date_control: "Fecha Control",
    days_left: "Días Restantes",
    delete_confirm_stocker: "¿Estás seguro de eliminar este stocker?",
    enter_valid_number: "Ingresa un número válido",
    fill_name_model: "Completa nombre y al menos un modelo",
    enter_valid_quantity: "Ingresa una cantidad válida",
    enter_valid_price: "Ingresa un precio válido",
    enter_model_name: "Ingresa nombre del modelo",
    error_generic: "Error",
    sale_recorded: "¡Venta registrada!",
    stocker_added: "¡Stocker añadido!",
    stocker_deleted: "¡Stocker eliminado!",
    stock_modified: "¡Stock modificado!",
    payment_confirmed: "¡Pago confirmado! El CEO será notificado.",
    pp_active_method: "Mi Método de Pago Activo",
    pp_whatsapp_hint: "Esta info aparecerá en el WhatsApp del CEO cada vez que presiones «Retirar Dinero».",
    pp_cash_label: "Cash",
    pp_zelle_id_label: "Número Zelle (teléfono/correo)",
    pp_cashapp_tag_label: "Cash App Tag",
    pp_account_holder: "Nombre en la cuenta",
    pp_full_name: "Nombre completo",
    pp_phone_hint: "Teléfono (visible en WhatsApp CEO)",
    pp_save_btn: "Guardar Método de Pago",
    pp_saving: "Guardando...",
    pp_choose_method: "Elige un método de pago",
    pp_fill_account: "Rellena ID cuenta y nombre",
    pp_saved: "Método de pago guardado",
    pp_save_error: "Error al guardar",
    cycle_recovery_label: "Recuperación del ciclo",
    cycle_recovery_detail: "+10 por ≥50% • +20 por 100%",
    manual_adjust_label: "Ajuste manual (CEO)",
    manual_adjust_detail: "puntos manuales",
    notifications_title: "Notificaciones",
    notif_all_read: "Marcar todas leídas",
    notif_none: "Sin notificaciones",
    notif_click_hint: "Clic para ver",
    select_payment_method: "Selecciona tu método de pago",
    payment_method_required: "Elige un método de pago primero",
    // Sales page
    record_sales_header: "Registrar Ventas",
    record_sales_btn: "Registrar Ventas",
    vape_description: "Descripción del vape",
    vape_description_num: "Descripción Vape",
    price_sold: "Precio Vendido ($)",
    subtotal: "Subtotal",
    total_sales_label: "Total Ventas",
    bonus_to_receive: "Bono a recibir",
    // Carryover
    carryover_cleared: "✅ Carryover del ciclo anterior vendido",
    carryover_cleared_hint: "Excelente — la prioridad principal está lista",
    carryover_pending_title: "⚠️ Vapes del ciclo anterior",
    carryover_pending_hint: "Deben venderse en el ciclo actual",
  },
};

export const LANGUAGES = [
  { code: "fr", label: "Français", flag: "🇫🇷" },
  { code: "ht", label: "Kreyòl", flag: "🇭🇹" },
  { code: "en", label: "English", flag: "🇺🇸" },
  { code: "es", label: "Español", flag: "🇪🇸" },
];

const LangContext = createContext(null);

export const LangProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => localStorage.getItem("vy_lang") || "fr");
  useEffect(() => {
    localStorage.setItem("vy_lang", lang);
    // Also expose on document for CSS-only rules if ever needed
    document.documentElement.setAttribute("data-lang", lang);
    setDomLanguage(lang);
  }, [lang]);
  const setLang = (l) => setLangState(l);
  const t = (key, fallback) => (TRANSLATIONS[lang] && TRANSLATIONS[lang][key]) || TRANSLATIONS.fr[key] || fallback || key;
  return <LangContext.Provider value={{ lang, setLang, t }}>{children}</LangContext.Provider>;
};

export const useLang = () => {
  const ctx = useContext(LangContext);
  if (!ctx) return { lang: "fr", setLang: () => {}, t: (k) => TRANSLATIONS.fr[k] || k };
  return ctx;
};
